var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75.685,
    height: 75.685,
    viewBox: "0 0 75.685 75.685",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_08_Cursor",
    "data-name": "08 Cursor",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M60.607,1H15.078A15.1,15.1,0,0,0,0,16.078V61.607A15.1,15.1,0,0,0,15.078,76.685H60.607A15.1,15.1,0,0,0,75.685,61.607V16.078A15.1,15.1,0,0,0,60.607,1ZM50.751,61.838H24.935a2.956,2.956,0,0,1,0-5.913H50.751a2.956,2.956,0,1,1,0,5.913Zm2.09-23.708L41.376,49.594a5,5,0,0,1-7.066,0L22.845,38.13a2.957,2.957,0,1,1,4.182-4.182l7.86,7.861v-23.3a2.956,2.956,0,0,1,5.913,0v23.3l7.86-7.861a2.957,2.957,0,0,1,4.182,4.182Z",
    fill: "#ef6f6f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download_icon.68bc3a549964ff0d2953b9b39b14781e.svg";
export { ForwardRef as ReactComponent };